export default "__VITE_ASSET__CPqjW3CY__"